import React, { FC, ReactNode, useEffect, useState } from "react";
import { Button, DatePicker, Input, Modal, Select, TimePicker} from "antd";
import _ from "lodash";

import 'antd/dist/antd.css';
import { RootState } from "reducers/rootReducer";

import {  Row, Col} from "antd";

import '../index.scss';
import {QuestionaireType} from '../../../constants/enums'

import moment from "moment";
import { DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import {MainActions, LogicalOps, MathOps, GeofenceOps} from './SurveyEnums';
import TextArea from "antd/lib/input/TextArea";

const mainActions = Object.values(MainActions).map(action=> { return {label: action, value: action}});
const logicalOps = Object.values(LogicalOps).map(op=> { return {label: op, value: op}});
const mathOps = Object.values(MathOps).map(op=> { return {label: op, value: op}});
const geofenceOps = Object.values(GeofenceOps).map(op=> { return {label: op, value: op}});

const LogicSurveyModal: FC<{ data: any; onCreateCancel:any, activeType: string }> = ({ data, onCreateCancel, activeType }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [questions, setQuiestions] = useState<any>([]);
  const [choiceCount, setChoiceCount] = useState<number>(data.logic.length || 0);

  const {survey}  = useSelector((state: RootState)=>  state.auth)

   useEffect(()=>{
      const surveyQuestions =  survey.questions.map((el, index)=>{return {label: `Q${index+1}`, value: el._id }}).filter(el=> el.value !== data._id);
      setQuiestions(surveyQuestions)
      setChoiceCount(data.logic.length)
   }, [survey])

  const [logic, setLogic] = useState<ILogic[]>(data.logic || [{
    ops: null,
    action: null,
    value: null,
    jQuestion: null
  }]);

  const handleOk = () => {
    setIsModalVisible(false);
    onCreateCancel()
  };

  let renderEle: ReactNode = "";

  switch (activeType) {
    case QuestionaireType.Location:
    case QuestionaireType.Signature:
    case QuestionaireType.ThreeButton:
    case QuestionaireType.Text:
    case QuestionaireType.Name:
    case QuestionaireType.File:
    case QuestionaireType.Tag:
    case QuestionaireType.TagNot:
    case QuestionaireType.YesNo:
      renderEle = (
        <Col>
          {_.times(choiceCount, (i) => {
            return (
            <Row
              key={i}
            >
   
              <Col className="mb-1 mt-2 mr-3" ><h3>Logic: {i+1}</h3></Col>
                  <Select
                       value={logic[i].action}
                       onChange={(value) => {
                       const newLogic = [...logic];
                       newLogic[i].action = value; 
                       setLogic([
                         ...newLogic,  
                      ])
                 }}
                 className=" mt-1 w-full"
                 placeholder="Select Action"
                 options={mainActions}
                 ></Select>
              {(logic[i].action   === MainActions.NotifyWait || logic[i].action   === MainActions.Notify)
               && 
              
                <TextArea
                 className="mt-1"
                autoSize={{ minRows: 3, maxRows: 5 }}
                value={logic[i].jQuestion}
                placeholder='Type here...'  
                onChange={(e) => { 
                  // data.value = e.target.value

                  const newLogic = [...logic];
                  newLogic[i].jQuestion = e.target.value; 
                  setLogic([
                      ...newLogic,  
                  ])

           }}  
                />
              }
              {logic[i].action   === MainActions.JumpToQuestion &&  <Select
              value={logic[i].jQuestion}
               onChange={(value) => {
                const newLogic = [...logic];
                newLogic[i].jQuestion = value; 
               setLogic([
                  ...newLogic,  
               ])
              }}
               className="mt-1 w-full"
               placeholder="Select Question to Jump"
               options={questions}
             ></Select>}

            </Row>)
          })}

            <Col span={24} className="t-right">
              <Button
                className="beam-btn mt-4"
                onClick={() => {
                  setChoiceCount(choiceCount + 1)
                  const newLogic = [...logic];
                  newLogic.push({
                    action: null,
                    ops: null,
                   value: null,
                   jQuestion: null
                  })
                    setLogic([
                    ...newLogic,
                ])
                }}
              >
                Add
              </Button>
            </Col>
          </Col> 
                );
    break;
   
    case QuestionaireType.Number:
    case QuestionaireType.Time:
    case QuestionaireType.Date:
    case QuestionaireType.DateTime:
    case QuestionaireType.Currency:
    case QuestionaireType.Bar:
      renderEle = (
        <Col>
          {_.times(choiceCount, (i) => {
            return (
            <Row
              key={i}
            >
              <h3 className="mb-1 mt-2">Logic: {i+1}</h3>
              <Select
              className="mt-1 w-full"
              value={logic[i].ops}
               onChange={(value) => {
                 const newLogic = [...logic];
                 newLogic[i].ops = value; 
              
                setLogic([
                   ...newLogic,  
                ])
              }}
               placeholder="Select Condition"
               options={mathOps}
             ></Select>

                        <Select
                  value={logic[i].action}
                 onChange={(value) => {
                  const newLogic = [...logic];
                  newLogic[i].action = value; 
                 setLogic([
                    ...newLogic,  
                 ])
              }}
               className=" mt-1 w-full"
               placeholder="Select Action"
               options={mainActions}
             ></Select>

{(logic[i].action   === MainActions.Notify || logic[i].action   === MainActions.Notify)
               && 
              
                <TextArea
                 className="mt-1"
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder='Type here...'  
                onChange={(e) => { 
                  data.value = e.target.value
           }}  
                />
              }

              {logic[i].action   === MainActions.JumpToQuestion &&  <Select
              value={logic[i].jQuestion}
               onChange={(value) => {
                const newLogic = [...logic];
                newLogic[i].jQuestion = value; 
               setLogic([
                  ...newLogic,  
               ])
              }}
               className="mt-1 w-full"
               placeholder="Select Question to Jump"
               options={questions}
             ></Select>}

              {activeType === (QuestionaireType.Number || QuestionaireType.Bar || QuestionaireType.Currency) &&   <Input  
                className="beam-input w-full"  
                type="number" 
                placeholder='Enter Number'  
                min={0} 
                value={logic[i].value}
                defaultValue={0}
                onChange={(e) => { 
                  const newLogic = [...logic];
                  newLogic[i].value = e.target.value; 
                 setLogic([
                    ...newLogic,  
                 ])
             }}    
             />}

          {activeType === QuestionaireType.Time  && <Row className="datetime-item w-full"> 
            <TimePicker  
            placeholder="Select Time" 
            suffixIcon={<DownOutlined />}
            value={ moment(logic[i].value).isValid() ? moment(logic[i].value) : moment()}
            onChange={(time:  moment.Moment | null)=>{
              const newLogic = [...logic];
              newLogic[i].value = time; 
             setLogic([
                ...newLogic,  
             ])
              }}
            /></Row>}

            {activeType === QuestionaireType.Date  && <Row  className=" w-full">

          <div className="datetime-item">
            <img src="/images/date.png" />
               <DatePicker 
             placeholder="Select Date" 
             suffixIcon={<DownOutlined />} 
             value={moment(logic[i].value).isValid() ? moment(logic[i].value) : moment()}
             onChange={(date:  moment.Moment | null)=>{
              const newLogic = [...logic];
              newLogic[i].value = date; 
             setLogic([
                ...newLogic,  
             ])
             }}
             />
             </div>

      </Row>}


      {activeType === QuestionaireType.DateTime  && <Row
         className=" w-full"
      >
          <div className="datetime-item">
            <img src="/images/date.png" />
               <DatePicker 
               showTime
               placeholder="Select Date" 
               suffixIcon={<DownOutlined />} 
               value={moment(logic[i].value).isValid() ? moment(logic[i].value) : moment()}
               onChange={(datetime:  moment.Moment | null)=>{
                const newLogic = [...logic];
                newLogic[i].value = datetime; 
               setLogic([
                  ...newLogic,  
               ])
                }}
             />
             </div>
      </Row>}
            </Row>)
          })}
            <Col span={24} className="t-right">
              <Button
                className="beam-btn mt-4"
                onClick={() => {
                  setChoiceCount(choiceCount + 1)
                  const newLogic = [...logic];
                  newLogic.push({
                    action: null,
                    ops: null,
                   value: null,
                   jQuestion: null
                  })
                    setLogic([
                    ...newLogic,
                ])
                }}
              >
                Add
              </Button>
            </Col>
          </Col> 
                );
    break;
    
    case QuestionaireType.GPS:
      renderEle = (
        <Col>
          {_.times(choiceCount, (i) => {
            return (
            <Row
              key={i}
            >
              <h3 className="mb-1 mt-2">Logic: {i+1}</h3>
              <Select
                value={logic[i].ops}
               onChange={(value) => {
                const newLogic = [...logic];
                newLogic[i].ops = value; 
               setLogic([
                  ...newLogic,  
               ])
                setLogic([...newLogic])
              }}
               className="w-full"
               placeholder="Select Condition"
               options={geofenceOps}
             ></Select>

                        <Select
                  value={logic[i].action}
                 onChange={(value) => {
                  const newLogic = [...logic];
                  newLogic[i].action = value; 
                 setLogic([
                    ...newLogic,  
                 ])
              }}
               className=" mt-1 w-full"
               placeholder="Select Action"
               options={mainActions}
             ></Select>
              {(logic[i].action   === MainActions.Notify || logic[i].action   === MainActions.Notify)
               && 
              
                <TextArea
                 className="mt-1"
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder='Type here...'  
                onChange={(e) => { 
                  data.value = e.target.value
           }}  
                />
              }
              {logic[i].action   === MainActions.JumpToQuestion &&  <Select
              value={logic[i].jQuestion}
               onChange={(value) => {
                const newLogic = [...logic];
                newLogic[i].jQuestion = value; 
               setLogic([
                  ...newLogic,  
               ])
              }}
               className="mt-1 w-full"
               placeholder="Select Question to Jump"
               options={questions}
             ></Select>}

            </Row>)
          })}

            <Col span={24} className="t-right">
              <Button
                className="beam-btn mt-4"
                onClick={() => {
                  setChoiceCount(choiceCount + 1)
                  const newLogic = [...logic];
                  newLogic.push({
                    action: null,
                    ops: null,
                   value: null,
                   jQuestion: null
                  })
                    setLogic([
                    ...newLogic,
                ])
                }}
              >
                Add
              </Button>
            </Col>
          </Col> 
                );

        
    break;

    case QuestionaireType.MultipleChoice:
         renderEle = (
        <Col>
          {_.times(choiceCount, (i) => {
            return (
            <Row
              key={i}
            >
              <h3 className="mb-1 mt-2">Logic: {i+1}</h3>
              <Select
              className="mt-1 w-full"
              value={logic[i].ops}
               onChange={(value) => {
                 const newLogic = [...logic];
                 newLogic[i].ops = value; 
                
                 if(value === LogicalOps.OR || value === LogicalOps.AND){
                   newLogic[i].value = [];
                 }
                setLogic([
                   ...newLogic,  
                ])
              }}
               placeholder="Select Condition"
               options={logicalOps}
             ></Select>
                        <Select
                  value={logic[i].action}
                 onChange={(value) => {
                  const newLogic = [...logic];
                  newLogic[i].action = value; 
                 setLogic([
                    ...newLogic,  
                 ])
              }}
               className=" mt-1 w-full"
               placeholder="Select Action"
               options={mainActions}
             ></Select>
              {(logic[i].action   === MainActions.Notify || logic[i].action   === MainActions.Notify)
               && 
              
                <TextArea
                 className="mt-1"
                autoSize={{ minRows: 3, maxRows: 5 }}
                placeholder='Type here...'  
                onChange={(e) => { 
                  data.value = e.target.value
           }}  
                />
              }
              {logic[i].action   === MainActions.JumpToQuestion &&  <Select
              value={logic[i].jQuestion}
               onChange={(value) => {
                const newLogic = [...logic];
                newLogic[i].jQuestion = value; 
               setLogic([
                  ...newLogic,  
               ])
              }}
               className="mt-1 w-full"
               placeholder="Select Question to Jump"
               options={questions}
             ></Select>}

           {(logic[i].ops   === LogicalOps.OR ||  logic[i].ops   === LogicalOps.AND) && 
           <Select
                 mode="multiple"
                 value={logic[i].value}
                 onChange={(values) => {
                  const newLogic = [...logic];
                  newLogic[i].value = values; 
                 setLogic([
                    ...newLogic,  
                 ])
              }}
               className="mt-1 w-full"
               placeholder="Select Choices"
               options={data.options.map(e=>{return {label: e, value: e}})}
             ></Select>
              }

         {logic[i].ops   === LogicalOps.NOT && 
           <Select
                 value={logic[i].value}
                 onChange={(value) => {
                  const newLogic = [...logic];
                  newLogic[i].value = value; 
                 setLogic([
                    ...newLogic,  
                 ])
              }}
               className="mt-1 w-full"
               placeholder="Select Choice"
               options={data.options.map(e=>{return {label: e, value: e}})}
             ></Select>       
             } 
            </Row>)
          })}

            <Col span={24} className="t-right">
              <Button
                className="beam-btn mt-4"
                onClick={() => {
                  setChoiceCount(choiceCount + 1)
                  const newLogic = [...logic];
                  newLogic.push({
                    action: null,
                    ops: null,
                   value: null,
                   jQuestion: null
                  })
                    setLogic([
                    ...newLogic,
                ])
                }}
              >
                Add
              </Button>
            </Col>
          </Col> 
                );
    break;
      default:
      renderEle = "";
  }

  const applyLogic= ()=>{
      data.logic = [...logic]
      onCreateCancel()
  }

  return (
    <Modal
      visible={isModalVisible}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={false}
    >
     <Col className="mb-3 t-center">
         <h3> Apply Logic to the Question:  </h3>
     </Col>

      {renderEle}
      <Row className="d-flex justify-content-center mt-4">
      <Col span={8} className="pl-2">
      <Button 
              className="beam-btn yellow-btn bordered w-full"
              onClick={applyLogic}
            >
              Apply
            </Button>
            </Col>

            <Col span={8} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleOk}
            >
              Cancel
      </Button>
            </Col>
            </Row>
    </Modal>
  );
};

export default LogicSurveyModal;




// logic obj Structure
// logic: {
//    ops: '',  //       greaterThan / AND               => string | null
//    value: '' / 32 / [option1, option2, option3]       => number | string | string[] | null
//    action: Jump to Q / Notify / Jump to GPS           => string | null
//    jQuestion:  / jump to Q1 / Q4                      => string | null
// }

